/** SSR/workers-safe menu sticky flags and class names (no DOM APIs). */

/** Whether the storefront main nav bar sticks on scroll (default: yes). Top bar + logo row never stick. */
export function resolveHeaderMenuSticky(value: unknown): boolean {
  if (value === false || value === 'false') {
    return false;
  }
  if (value === true || value === 'true') {
    return true;
  }
  return true;
}

export function headerNavbarClassName(): string {
  return 'navbar';
}

export function headerDesktopNavClassName(): string {
  return 'navbar-nav hide-mobile';
}

export function headerNavBarShellClassName(): string {
  return 'storefront-nav-bar hide-mobile';
}
